import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { scrollToTop } from "../../../JS/scrollToTop";

const Event8_Success = (props) => {
    const { t } = props;

    useEffect(() => {

        scrollToTop()
    }, [])

    return (
        <>
            <header className="inner-pages w-footer subpages">
                {/* <a className="button-back" onClick={props.back}></a> */}
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>

            <section class="widgets spa-listing spa-details completed">
                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl && (
                        <div class="widget-header-img">
                            <img
                                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                                alt={props.currentWidgetObj.displayName}
                            />
                        </div>
                    )}
                    <div class="widget-header-title">
                        {t(`events.headingSuccess`)}
                    </div>
                    <div class="widget-header-subtitle">
                        {t(`events.sub_headingSuccess`)}
                    </div>
                </div>



                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="row">
                            <div class="col">
                                <div class="detail-body stay-body">
                                    <div class="stay-info-details">
                                        <div class="stay-info-body">

                                            <p style={{ whiteSpace: "pre-line" }}>
                                                {t("events.success_page_body").replace("#EVENT_NAME", props.selectedEvent.eventName)}
                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-controls">
                                <button
                                    onClick={() => {
                                        props.next();
                                    }}
                                >
                                    {t(`events.okay`)}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : ""

    }
}

export default connect(
    mapStateToProps,
    {}
)(withTranslation("translations")(Event8_Success));
